import axiosInstance from '../utils/axios.instance';
import { API_ENDPOINTS } from '../config/api.config';

/**
 * Service de gestion des éléments déjà vus par l'utilisateur
 * Permet de persister l'état d'ouverture des commissions et sous-dossiers
 */
export const viewedItemsService = {
  /**
   * Récupérer toutes les commissions déjà vues par l'utilisateur connecté
   * @returns {Promise<Array<number>>} Liste des IDs de commissions vues
   */
  getViewedCommissions: async () => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.VIEWED_ITEMS.COMMISSIONS);
      // Le backend retourne un tableau d'IDs
      return response.data || [];
    } catch (error) {
      console.error('Erreur lors de la récupération des commissions vues:', error);
      // En cas d'erreur, retourner un tableau vide
      return [];
    }
  },

  /**
   * Marquer une commission comme vue
   * @param {number} commissionId - ID de la commission à marquer comme vue
   * @returns {Promise<void>}
   */
  markCommissionAsViewed: async (commissionId) => {
    try {
      await axiosInstance.post(API_ENDPOINTS.VIEWED_ITEMS.MARK_COMMISSION(commissionId));
    } catch (error) {
      console.error('Erreur lors du marquage de la commission comme vue:', error);
      throw error;
    }
  },

  /**
   * Récupérer tous les sous-dossiers déjà vus par l'utilisateur connecté
   * @returns {Promise<Array<number>>} Liste des IDs de sous-dossiers vus
   */
  getViewedFolders: async () => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.VIEWED_ITEMS.FOLDERS);
      return response.data || [];
    } catch (error) {
      console.error('Erreur lors de la récupération des sous-dossiers vus:', error);
      return [];
    }
  },

  /**
   * Marquer un sous-dossier comme vu
   * @param {number} commissionId - ID de la commission
   * @param {number} folderId - ID du sous-dossier à marquer comme vu
   * @returns {Promise<void>}
   */
  markFolderAsViewed: async (commissionId, folderId) => {
    try {
      await axiosInstance.post(API_ENDPOINTS.VIEWED_ITEMS.MARK_FOLDER(commissionId, folderId));
    } catch (error) {
      console.error('Erreur lors du marquage du sous-dossier comme vu:', error);
      throw error;
    }
  },

  /**
   * Réinitialiser toutes les vues de l'utilisateur (pour tests ou préférences)
   * @returns {Promise<void>}
   */
  resetAllViewed: async () => {
    try {
      await axiosInstance.delete(API_ENDPOINTS.VIEWED_ITEMS.RESET);
    } catch (error) {
      console.error('Erreur lors de la réinitialisation des vues:', error);
      throw error;
    }
  },
};

export default viewedItemsService;
